import Button from '@passkeys/ui/button';

import useExchangeResult from '../hooks/use-exchange-result.js';

interface SubmitButtonProps {
  visible: boolean;
  loading: boolean;
  disabled: boolean;
  className?: string;
  onPress: () => void;
}

function SubmitButton({
  visible,
  loading,
  disabled,
  className,
  onPress,
}: SubmitButtonProps) {
  const { status } = useExchangeResult();

  if (!visible) {
    return null;
  }

  return (
    <Button
      className={className}
      disabled={disabled}
      loading={loading || status === 'started'}
      onClick={onPress}
      size="large"
      dataTestId="submit-swap-button"
    >
      Continue
    </Button>
  );
}

export default SubmitButton;
